import { render, staticRenderFns } from "./Chat_Specification.vue?vue&type=template&id=03a95bca&scoped=true"
import script from "./Chat_Specification.vue?vue&type=script&lang=js"
export * from "./Chat_Specification.vue?vue&type=script&lang=js"
import style0 from "./Chat_Specification.vue?vue&type=style&index=0&id=03a95bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a95bca",
  null
  
)

export default component.exports